import type { SerializedStyles, Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint } from '@twistopayments/design-system/styles'

import type { HeadlineSize } from './headline'

export const size = (theme: Theme): Record<HeadlineSize, SerializedStyles> => ({
  default: css`
    width: ${theme.spacing[80]};
    height: ${theme.spacing[80]};
    margin-bottom: ${theme.spacing[24]};

    ${breakpoint.down('sm')} {
      width: ${theme.spacing[64]};
      height: ${theme.spacing[64]};
      margin-bottom: ${theme.spacing[16]};
    }
  `,
  large: css`
    width: ${theme.spacing[96]};
    height: ${theme.spacing[96]};
    margin-bottom: ${theme.spacing[48]};

    ${breakpoint.down('sm')} {
      width: ${theme.spacing[80]};
      height: ${theme.spacing[80]};
      margin-bottom: ${theme.spacing[32]};
    }
  `,
  xl: css`
    width: ${theme.spacing[96]};
    height: ${theme.spacing[96]};
    margin-bottom: ${theme.spacing[48]};

    ${breakpoint.down('sm')} {
      width: ${theme.spacing[80]};
      height: ${theme.spacing[80]};
      margin-bottom: ${theme.spacing[32]};
    }
  `,
})
